
import { nthChild } from 'vessel/utils'

export default {
  props: {
    posts: {
      type: Array,
      default: null
    }
  },
  methods: {
    isFull(index) {
      return nthChild((index + 1), '5n + 1')
    },
    colSpan(index) {
      if (this.$screen.lg) {
        return this.isFull(index) ? 2 : 1
      } else {
        return { all: 2, md: 1 }
      }
    },
    currentComponent(index) {
      if (this.$screen.lg && this.isFull(index)) {
        return 'PostCardHorizontal'
      } else {
        return 'PostCardVertical'
      }
    }
  }
}
